import NewAppointmentDialog from './NewAppointmentDialog.container';

export default NewAppointmentDialog;
